const homeBt = {
	hero: {
		title: 'གྲམ་གྱི་ཚོང་ཁང་ལ་ཕེབས་པར་དགའ་ཤོག',
		subtitle: 'ཁྱེད་ལ་དགོས་པའི་ཐེབས་ཚང་མ་འཚོལ།'
	},
	search: {
		placeholderDefault: 'ཐེབས་འཚོལ།',
		typewriterPlaceholders: [
			'ཤིང་ཏོག་སྣ་ཚོགས།',
			'ལྕགས་སྣོལ།',
			'རྩིས་འཁོར།',
			'བཟས་ཆས།',
			'འཕྲུལ་ཆས་ (Electronics)'
		]
	},
	partners: {
		heading: 'རྩིས་སྦྱོར་མཛོད་ཚུ',
		subheading: 'ཡིད་ཆེས་བྱེད་སྲོལ་ཡོད་པའི་ཚོགས་པ་ཚུ་དང་མཉམ་ལས།'
	}
};

export default homeBt;


